import { AgenturNameCell } from 'app/components/shared/AgenturName.cell';
import { Table } from 'app/components/table/table';
import { ITableColumn, TableModel } from 'app/components/table/table.model';
import { useStore } from 'app/context';
import { LeadNowKwkVM } from 'app/stores/ui/agt.leadnow.ui.store';
import { observer } from 'mobx-react';
import { useEffect, useMemo, useState } from 'react';

export const LeadNowKwkList = observer(() => {
	const { berichteUiiStore, agtLeadNowUiStore, agenturListUiStore } = useStore();
	const [items, setItems] = useState<LeadNowKwkVM[]>([]);
	const [loaded, setLoaded] = useState(false);

	const tm = useMemo(() => {
		const tm = new TableModel<LeadNowKwkVM, number>();
		const cols: ITableColumn<LeadNowKwkVM, number>[] = [
			{
				label: 'Agentur',
				path: 'agt.name',
				sortBy: 'agt.name',
				render: AgenturNameCell,
			},
			{
				label: 'Status',
				path: 'kwkStatusLabel',
				sortBy: 'kwkStatusLabel',
			},
		];

		tm.sortBy = 'agt.name';
		tm.setCols(cols);
		tm.idProperty = 'agtId';
		tm.idType = 'number';

		return tm;
	}, []);

	useEffect(() => {
		agtLeadNowUiStore.loadKwkItems().then((res) => {
			setItems(res);
			setLoaded(true);
		});
	}, [agtLeadNowUiStore]);

	useEffect(() => {
		let filtered = items;
		if (berichteUiiStore.selectedAgt) {
			const agtId = berichteUiiStore.selectedAgt.agtId;
			filtered = filtered.filter((i) => i.agt.agtId === agtId);
		} else {
			filtered = agenturListUiStore.applyFilterOnAgt(filtered) as LeadNowKwkVM[];
			agenturListUiStore.updateCounts(filtered.length);
		}
		tm.setRowData(filtered);
		tm.sort();
	}, [tm, items, berichteUiiStore.selectedAgt, agenturListUiStore, agenturListUiStore.filterHasChanged]);

	return (
		<div className="table-container">
			{loaded && tm.data.length === 0 ? (
				<div className="pad-1rem">Keine Kunden werben Kunden Daten</div>
			) : (
				<Table stickyHeader={true} tm={tm} />
			)}
		</div>
	);
});
